import classNames from 'classnames/bind';
import Icon, { IconVariant } from 'src/components/ui-kit/icon/icon';
import styles from './form.module.scss';
import FormError from './_error';
import { FormTextInputProps, getError, getValue, onBlur } from './_text-input';
import { IMaskInput } from 'react-imask';

const classesContext = classNames.bind(styles);

export default function FormTextInputRange<T>({
  formik,
  name,
  isAsteriskShown,
  isBordered,
  isLockShown,
  className,
  min,
  max,
  ...inputProps
}: FormTextInputProps<T>): JSX.Element {
  const error = getError<T>(formik, name);

  return (
    <div
      className={classesContext([
        'form_group',
        {
          form_group__required: isAsteriskShown,
          form_group__bordered: isBordered,
          form_group__error: error
        },
        className
      ])}
    >
      <IMaskInput
        mask={Number}
        min={min as any}
        max={max as any}
        onChange={formik?.handleChange}
        onBlur={() => onBlur(formik, name)}
        name={name}
        value={getValue<T>(formik, name) as any}
        type='number'
        className={styles.form_control}
        {...inputProps}
      />
      {isLockShown && (
        <span className={styles.form_group__disabled}>
          <Icon variant={IconVariant.LOCK} />
        </span>
      )}
      {error && <FormError error={error} />}
    </div>
  );
}
